import './App.css';
import GameBoard from './components/gameboard';

function App() {
    return (
        <div className="App">
            <GameBoard></GameBoard>
        </div>
    );
}

export default App;
